import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBook = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2.25 9C2.25 3.75 3.75069 2.25 9.00034 2.25C14.25 2.25 15.75 3.75 15.75 9C15.75 14.25 14.1923 15.75 9.00034 15.75C3.80838 15.75 2.25 14.25 2.25 9Z",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.25 7.5H11.25",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.25 10.5H12.75",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.81223 15.75C5.81223 15.75 5.62493 12.3748 5.625 8.99992C5.62507 5.625 5.8125 2.25 5.8125 2.25",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgBook);
export { ForwardRef as ReactComponent };
